import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiDownload, FiUser } from "react-icons/fi";

import u1 from "../../../assets/img/users/user-31.jpg";
import u2 from "../../../assets/img/users/user-32-1.jpg";
import u3 from "../../../assets/img/users/user-29-1.jpg";
import u4 from "../../../assets/img/users/user-56.jpg";

export default function PendingPayments() {
  const users = [u1, u2, u3, u4];

  return (
    <>
      <Card className="pending-card h-100">
        <Card.Body>
          {/* HEADER */}
          <div className="header-row">
            <h4 className="title">Pending Payments</h4>

            <div className="download-btn">
              <FiDownload />
            </div>
          </div>

          {/* AMOUNT */}
          <div className="amount-row">
            <span className="amount-label">Total Amount</span>
            <span className="amount-value">$69856</span>
          </div>

          {/* AVATAR GROUP */}
          <div className="avatar-group">
            {users.map((img, i) => (
              <img key={i} src={img} alt="user" />
            ))}
            <div className="avatar-more">+9</div>
          </div>

          {/* BUTTON */}
          <Button className="transfer-btn">
            <FiUser className="me-2" />
            Transfer Now
          </Button>
        </Card.Body>
      </Card>

      {/* INTERNAL CSS */}
      <style>{`

      .pending-card{
        border-radius:5px;
        border:2px solid #e6e6e6;
        padding:5px;
      }

      .header-row{
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin-bottom:20px;
      }

      .title{
        font-weight:700;
        text-decoration:underline;
        margin:0;
      }

      .download-btn{
        width:40px;
        height:40px;
        border-radius:50%;
        border:1px solid #e5e5e5;
        display:flex;
        align-items:center;
        justify-content:center;
        cursor:pointer;
        background:#f7f7f7;
        font-size:18px;
      }

      .amount-row{
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin-bottom:20px;
      }

      .amount-label{
        color:#7b8190;
        font-size:15px;
      }

      .amount-value{
        font-weight:700;
        font-size:18px;
      }

      .avatar-group{
        display:flex;
        align-items:center;
        margin-bottom:20px;
      }

      .avatar-group img{
        width:38px;
        height:38px;
        border-radius:50%;
        border:3px solid #fff;
        margin-left:-10px;
        object-fit:cover;
      }

      .avatar-group img:first-child{
        margin-left:0;
      }

      .avatar-more{
        width:38px;
        height:38px;
        border-radius:50%;
        background:#f3f3f3;
        display:flex;
        align-items:center;
        justify-content:center;
        margin-left:-10px;
        font-weight:600;
        color:#333;
        border:1px solid #ddd;
      }

      .transfer-btn{
        width:100%;
        background:#0d1b2a;
        border:none;
        padding:12px;
        border-radius:8px;
        font-weight:600;
        font-size:15px;
      }

      .transfer-btn:hover{
        background:#081220;
      }

      /* MOBILE RESPONSIVE */

      @media(max-width:576px){

        .title{
          font-size:16px;
        }

        .amount-value{
          font-size:16px;
        }

        .avatar-group img,
        .avatar-more{
          width:34px;
          height:34px;
        }

      }

      `}</style>
    </>
  );
}
